
import { MediaFileExtension } from '../utils/constants';


export const getFileExtension = (fileName: string) => {
    if (fileName) {
        const splittedFileName = fileName?.split('.');
        return splittedFileName[splittedFileName.length - 1];
    }
    return '';
}

export const getStorageFileName = (files: File[], accountId: any) => {
    const extension = (files && files.length > 0) ? getFileExtension(files[0]?.name) : MediaFileExtension.Wav.toString();
    return `${accountId}-${Date.now()}.${extension}`;
}